var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55738 3.18033C1.6977 3.18033 1 3.87492 1 4.73459V17.1967C1 18.0564 1.6977 18.7541 2.55738 18.7541H18.4426C19.3023 18.7541 20 18.0564 20 17.1967V4.73459C20 3.87803 19.3023 3.18033 18.4426 3.18033",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98364 1V4.42623",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6558 1V4.42623",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3276 1V4.42623",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98372 10.1885C6.5858 10.1885 7.07388 9.70044 7.07388 9.09836C7.07388 8.49628 6.5858 8.00819 5.98372 8.00819C5.38164 8.00819 4.89355 8.49628 4.89355 9.09836C4.89355 9.70044 5.38164 10.1885 5.98372 10.1885Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6558 10.1885C11.2579 10.1885 11.746 9.70044 11.746 9.09836C11.746 8.49628 11.2579 8.00819 10.6558 8.00819C10.0538 8.00819 9.56567 8.49628 9.56567 9.09836C9.56567 9.70044 10.0538 10.1885 10.6558 10.1885Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3277 10.1885C15.9298 10.1885 16.4179 9.70044 16.4179 9.09836C16.4179 8.49628 15.9298 8.00819 15.3277 8.00819C14.7256 8.00819 14.2375 8.49628 14.2375 9.09836C14.2375 9.70044 14.7256 10.1885 15.3277 10.1885Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98372 15.1721C6.5858 15.1721 7.07388 14.684 7.07388 14.082C7.07388 13.4799 6.5858 12.9918 5.98372 12.9918C5.38164 12.9918 4.89355 13.4799 4.89355 14.082C4.89355 14.684 5.38164 15.1721 5.98372 15.1721Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6558 15.1721C11.2579 15.1721 11.746 14.684 11.746 14.082C11.746 13.4799 11.2579 12.9918 10.6558 12.9918C10.0538 12.9918 9.56567 13.4799 9.56567 14.082C9.56567 14.684 10.0538 15.1721 10.6558 15.1721Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3277 15.1721C15.9298 15.1721 16.4179 14.684 16.4179 14.082C16.4179 13.4799 15.9298 12.9918 15.3277 12.9918C14.7256 12.9918 14.2375 13.4799 14.2375 14.082C14.2375 14.684 14.7256 15.1721 15.3277 15.1721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.92b1cc80.svg";
export { ForwardRef as ReactComponent };